import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FiRefreshCw, FiGrid, FiUsers, FiAlertCircle, FiPlus, FiEdit2, FiTrash2, FiEye, FiCalendar } from 'react-icons/fi';
import './Kelas.css';

const Kelas = () => {
  const [kelasList, setKelasList] = useState([]);
  const [stats, setStats] = useState({
    total_kelas: 0,
    total_peserta: 0,
    kelas_tanpa_dosen: 0,
    rata_rata_peserta: 0
  });
  const [loading, setLoading] = useState(true);
  const [syncing, setSyncing] = useState(false);
  const [showSyncModal, setShowSyncModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [showPesertaModal, setShowPesertaModal] = useState(false);
  const [pesertaList, setPesertaList] = useState([]);
  const [loadingPeserta, setLoadingPeserta] = useState(false);
  const [selectedKelas, setSelectedKelas] = useState(null);
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(false);
  
  const [filters, setFilters] = useState({
    search: '',
    id_semester: '',
    id_prodi: ''
  });
  
  const [syncConfig, setSyncConfig] = useState({
    id_semester: '',
    id_prodi: '',
    mode: 'upsert',
    limit: 100,
    includePeserta: true
  });
  
  const [formData, setFormData] = useState({
    nama_kelas_kuliah: '',
    kode_mata_kuliah: '',
    nama_mata_kuliah: '',
    sks: '',
    nama_semester: '',
    nama_program_studi: '',
    nama_dosen: '',
    jumlah_mahasiswa: '0',
    kapasitas: ''
  });
  
  const [alert, setAlert] = useState(null);

  useEffect(() => {
    fetchKelas();
    fetchStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  const fetchKelas = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.get('http://localhost:5000/api/kelas', {
        headers: { Authorization: `Bearer ${token}` },
        params: filters
      });

      if (response.data.success) {
        setKelasList(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching kelas:', error);
      showAlert('error', 'Gagal mengambil data kelas');
    } finally {
      setLoading(false);
    }
  };

  const fetchStats = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get('http://localhost:5000/api/kelas/stats', {
        headers: { Authorization: `Bearer ${token}` },
        params: { id_semester: filters.id_semester, id_prodi: filters.id_prodi }
      });

      if (response.data.success) {
        setStats(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching stats:', error);
    }
  };

  const showAlert = (type, message) => {
    setAlert({ type, message });
    setTimeout(() => setAlert(null), 5000);
  };

  const handlePesertaClick = async (kelas) => {
    try {
      setSelectedKelas(kelas);
      setShowPesertaModal(true);
      setLoadingPeserta(true);
      setPesertaList([]);

      const token = localStorage.getItem('token');
      const response = await axios.get(
        `http://localhost:5000/api/kelas/${kelas._id}/peserta`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      if (response.data.success) {
        setPesertaList(response.data.data.peserta);
      }
    } catch (error) {
      console.error('Error fetching peserta:', error);
      showAlert('error', 'Gagal mengambil data peserta kelas');
      setPesertaList([]);
    } finally {
      setLoadingPeserta(false);
    }
  };

  const handleSync = async () => {
    try {
      if (!syncConfig.id_semester) {
        showAlert('error', 'Semester wajib dipilih');
        return;
      }

      setSyncing(true);
      const token = localStorage.getItem('token');
      
      const response = await axios.post(
        'http://localhost:5000/api/kelas/sync',
        syncConfig,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      if (response.data.success) {
        const { inserted, updated, skipped, mode, peserta_fetched } = response.data.data;
        let message = `Sinkronisasi berhasil (${mode}):\n`;
        message += `✅ Inserted: ${inserted}\n`;
        message += `✏️ Updated: ${updated}`;
        if (skipped > 0) message += `\n⏭️ Skipped: ${skipped}`;
        if (peserta_fetched > 0) message += `\n👥 Peserta kelas: ${peserta_fetched} kelas`;
        
        showAlert('success', message);
        setShowSyncModal(false);
        fetchKelas();
        fetchStats();
      }
    } catch (error) {
      console.error('Error syncing kelas:', error);
      showAlert('error', error.response?.data?.message || 'Gagal sinkronisasi kelas');
    } finally {
      setSyncing(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const resetForm = () => {
    setFormData({
      nama_kelas_kuliah: '',
      kode_mata_kuliah: '',
      nama_mata_kuliah: '',
      sks: '',
      nama_semester: '',
      nama_program_studi: '',
      nama_dosen: '',
      jumlah_mahasiswa: '0',
      kapasitas: ''
    });
  };

  const handleAddKelas = async () => {
    try {
      setSaving(true);
      const token = localStorage.getItem('token');
      
      const response = await axios.post(
        'http://localhost:5000/api/kelas',
        formData,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      if (response.data.success) {
        showAlert('success', 'Kelas berhasil ditambahkan');
        setShowAddModal(false);
        resetForm();
        fetchKelas();
        fetchStats();
      }
    } catch (error) {
      console.error('Error adding kelas:', error);
      showAlert('error', error.response?.data?.message || 'Gagal menambahkan kelas');
    } finally {
      setSaving(false);
    }
  };

  const handleEditClick = (kelas) => {
    setSelectedKelas(kelas);
    setFormData({
      nama_kelas_kuliah: kelas.nama_kelas_kuliah || '',
      kode_mata_kuliah: kelas.kode_mata_kuliah || '',
      nama_mata_kuliah: kelas.nama_mata_kuliah || '',
      sks: kelas.sks || '',
      nama_semester: kelas.nama_semester || '',
      nama_program_studi: kelas.nama_program_studi || '',
      nama_dosen: kelas.nama_dosen || '',
      jumlah_mahasiswa: kelas.jumlah_mahasiswa || '0',
      kapasitas: kelas.kapasitas || ''
    });
    setShowEditModal(true);
  };

  const handleUpdateKelas = async () => {
    try {
      setSaving(true);
      const token = localStorage.getItem('token');
      
      const response = await axios.put(
        `http://localhost:5000/api/kelas/${selectedKelas._id}`,
        formData,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      if (response.data.success) {
        showAlert('success', 'Kelas berhasil diperbarui');
        setShowEditModal(false);
        setSelectedKelas(null);
        resetForm();
        fetchKelas();
        fetchStats();
      }
    } catch (error) {
      console.error('Error updating kelas:', error);
      showAlert('error', error.response?.data?.message || 'Gagal memperbarui kelas');
    } finally {
      setSaving(false);
    }
  };

  const handleDeleteClick = (kelas) => {
    setSelectedKelas(kelas);
    setShowDeleteModal(true);
  };

  const handleDeleteKelas = async () => {
    try {
      setDeleting(true);
      const token = localStorage.getItem('token');
      
      const response = await axios.delete(
        `http://localhost:5000/api/kelas/${selectedKelas._id}`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      if (response.data.success) {
        showAlert('success', 'Kelas berhasil dihapus');
        setShowDeleteModal(false);
        setSelectedKelas(null);
        fetchKelas();
        fetchStats();
      }
    } catch (error) {
      console.error('Error deleting kelas:', error);
      showAlert('error', error.response?.data?.message || 'Gagal menghapus kelas');
    } finally {
      setDeleting(false);
    }
  };

  const handleDetailClick = (kelas) => {
    setSelectedKelas(kelas);
    setShowDetailModal(true);
  };

  return (
    <div className="kelas-container">
      {/* Alert */}
      {alert && (
        <div className={`alert alert-${alert.type}`}>
          <FiAlertCircle />
          <span>{alert.message}</span>
        </div>
      )}

      {/* Header */}
      <div className="kelas-header">
        <h2><FiGrid /> Kelas Kuliah</h2>
        <div className="header-actions">
          <button 
            className="btn-add" 
            onClick={() => setShowAddModal(true)}
          >
            <FiPlus /> Tambah Kelas
          </button>
          <button 
            className="btn-sync" 
            onClick={() => setShowSyncModal(true)}
            disabled={syncing}
          >
            <FiRefreshCw className={syncing ? 'spinning' : ''} />
            {syncing ? 'Menyinkronkan...' : 'Sinkronisasi'}
          </button>
        </div>
      </div>

      {/* Statistics */}
      <div className="kelas-stats">
        <div className="stat-card primary">
          <div className="stat-icon">
            <FiGrid />
          </div>
          <div className="stat-info">
            <h3>{stats.total_kelas}</h3>
            <p>Total Kelas</p>
          </div>
        </div>
        <div className="stat-card success">
          <div className="stat-icon">
            <FiUsers />
          </div>
          <div className="stat-info">
            <h3>{stats.total_peserta}</h3>
            <p>Total Peserta</p>
          </div>
        </div>
        <div className="stat-card warning">
          <div className="stat-icon">
            <FiAlertCircle />
          </div>
          <div className="stat-info">
            <h3>{stats.kelas_tanpa_dosen}</h3>
            <p>Tanpa Dosen</p>
          </div>
        </div>
        <div className="stat-card info">
          <div className="stat-icon">
            <FiUsers />
          </div>
          <div className="stat-info">
            <h3>{stats.rata_rata_peserta}</h3>
            <p>Rata-rata Peserta/Kelas</p>
          </div>
        </div>
      </div>

      {/* Filters */}
      <div className="kelas-filters">
        <input
          type="text"
          name="search"
          placeholder="🔍 Cari mata kuliah atau dosen..."
          value={filters.search}
          onChange={handleFilterChange}
          className="filter-search"
        />
        <select
          name="id_semester"
          value={filters.id_semester}
          onChange={handleFilterChange}
          className="filter-input"
        >
          <option value="">📅 Semua Semester</option>
          <option value="20241">2024/2025 Ganjil</option>
          <option value="20242">2024/2025 Genap</option>
          <option value="20231">2023/2024 Ganjil</option>
          <option value="20232">2023/2024 Genap</option>
          <option value="20221">2022/2023 Ganjil</option>
          <option value="20222">2022/2023 Genap</option>
        </select>
        <select
          name="id_prodi"
          value={filters.id_prodi}
          onChange={handleFilterChange}
          className="filter-input"
        >
          <option value="">🎓 Semua Program Studi</option>
          <option value="509e3f38-e7f7-4319-8529-51b906e79a7b">S1 Kesehatan Masyarakat</option>
          <option value="ac552e5c-3a71-41d6-9183-344412821873">S1 Keperawatan</option>
          <option value="0cd363ea-503f-4468-9f16-b6163b3bdd99">Profesi Ners</option>
        </select>
        <button
          className="btn-reset-filter"
          onClick={() => setFilters({ search: '', id_semester: '', id_prodi: '' })}
          title="Reset Filter"
        >
          <FiRefreshCw /> Reset
        </button>
      </div>

      {/* Table */}
      <div className="kelas-table-container">
        {loading ? (
          <div className="loading">
            <FiRefreshCw className="spinning" />
            <p>Memuat data kelas...</p>
          </div>
        ) : kelasList.length === 0 ? (
          <div className="empty-state">
            <FiGrid />
            <p>Belum ada data kelas</p>
            <small>Gunakan tombol "Sinkronisasi" untuk mengambil data dari NEO Feeder</small>
          </div>
        ) : (
          <table className="kelas-table">
            <thead>
              <tr>
                <th style={{ width: '50px', textAlign: 'center' }}>No</th>
                <th>Mata Kuliah</th>
                <th>SKS</th>
                <th>Dosen</th>
                <th>Semester</th>
                <th>Prodi</th>
                <th>Peserta</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {kelasList.map((kelas, index) => (
                <tr key={kelas._id}>
                  <td style={{ textAlign: 'center', fontWeight: '600', color: '#7f8c8d' }}>
                    {index + 1}
                  </td>
                  <td>
                    <div>
                      <strong>{kelas.kode_mata_kuliah}</strong>
                      <br />
                      <small>{kelas.nama_mata_kuliah}</small>
                    </div>
                  </td>
                  <td>{kelas.sks}</td>
                  <td>
                    <small>{kelas.nama_dosen || '-'}</small>
                  </td>
                  <td>{kelas.nama_semester}</td>
                  <td>
                    <small>{kelas.nama_program_studi}</small>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <button 
                      className="btn-peserta-count"
                      onClick={() => handlePesertaClick(kelas)}
                      title="Klik untuk melihat daftar peserta"
                    >
                      <FiUsers style={{ marginRight: '4px', fontSize: '14px' }} />
                      {kelas.jumlah_mahasiswa || '0'}
                    </button>
                  </td>
                  <td>
                    <div className="action-buttons">
                      <button
                        className="btn-action btn-view"
                        onClick={() => handleDetailClick(kelas)}
                        title="Lihat Detail"
                      >
                        <FiEye />
                      </button>
                      <button
                        className="btn-action btn-edit"
                        onClick={() => handleEditClick(kelas)}
                        title="Edit Kelas"
                      >
                        <FiEdit2 />
                      </button>
                      <button
                        className="btn-action btn-delete"
                        onClick={() => handleDeleteClick(kelas)}
                        title="Hapus Kelas"
                      >
                        <FiTrash2 />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Sync Modal */}
      {showSyncModal && (
        <div className="modal-overlay" onClick={() => setShowSyncModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Sinkronisasi Kelas dari NEO Feeder</h3>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label>Semester <span className="required">*</span></label>
                <select
                  value={syncConfig.id_semester}
                  onChange={(e) => setSyncConfig({ ...syncConfig, id_semester: e.target.value })}
                  required
                >
                  <option value="">-- Pilih Semester --</option>
                  <option value="20241">2024/2025 Ganjil</option>
                  <option value="20242">2024/2025 Genap</option>
                  <option value="20231">2023/2024 Ganjil</option>
                  <option value="20232">2023/2024 Genap</option>
                  <option value="20221">2022/2023 Ganjil</option>
                  <option value="20222">2022/2023 Genap</option>
                </select>
                <small>Pilih semester yang akan disinkronkan</small>
              </div>
              <div className="form-group">
                <label>Program Studi</label>
                <select
                  value={syncConfig.id_prodi}
                  onChange={(e) => setSyncConfig({ ...syncConfig, id_prodi: e.target.value })}
                >
                  <option value="">Semua Program Studi</option>
                  <option value="509e3f38-e7f7-4319-8529-51b906e79a7b">S1 Kesehatan Masyarakat</option>
                  <option value="ac552e5c-3a71-41d6-9183-344412821873">S1 Keperawatan</option>
                  <option value="0cd363ea-503f-4468-9f16-b6163b3bdd99">Profesi Ners</option>
                </select>
                <small>Kosongkan untuk sinkronisasi semua program studi</small>
              </div>
              <div className="form-group">
                <label>Mode Sinkronisasi <span className="required">*</span></label>
                <select
                  value={syncConfig.mode || 'insert'}
                  onChange={(e) => setSyncConfig({ ...syncConfig, mode: e.target.value })}
                >
                  <option value="insert">Insert - Hanya tambah data baru</option>
                  <option value="update">Update - Hanya update data yang sudah ada</option>
                  <option value="upsert">Upsert - Insert baru & Update yang ada</option>
                </select>
                <small>
                  {syncConfig.mode === 'insert' && 'Data yang sudah ada akan diabaikan'}
                  {syncConfig.mode === 'update' && 'Hanya data yang sudah ada yang akan diperbarui'}
                  {(!syncConfig.mode || syncConfig.mode === 'upsert') && 'Kombinasi insert dan update (direkomendasikan)'}
                </small>
              </div>
              <div className="form-group">
                <label>Limit Data</label>
                <select
                  value={syncConfig.limit}
                  onChange={(e) => setSyncConfig({ ...syncConfig, limit: e.target.value })}
                >
                  <option value="50">50 Data</option>
                  <option value="100">100 Data</option>
                  <option value="500">500 Data</option>
                  <option value="1000">1000 Data</option>
                  <option value="5000">5000 Data (All)</option>
                </select>
              </div>
              
              <div className="form-group">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={syncConfig.includePeserta}
                    onChange={(e) => setSyncConfig({ ...syncConfig, includePeserta: e.target.checked })}
                  />
                  <span>Sertakan data peserta kelas (GetPesertaKelasKuliah)</span>
                </label>
                <small style={{ marginLeft: '24px', display: 'block', marginTop: '5px' }}>
                  {syncConfig.includePeserta 
                    ? '✅ Data peserta mahasiswa untuk setiap kelas akan diambil dari NEO Feeder' 
                    : '⚠️ Hanya data kelas yang akan disinkronkan, tanpa data peserta'}
                </small>
              </div>

              <div className="alert alert-info">
                <FiAlertCircle />
                <span>
                  Data kelas akan diambil dari NEO Feeder menggunakan fungsi GetListKelasKuliah.
                  {syncConfig.includePeserta && ' Data peserta akan diambil menggunakan GetPesertaKelasKuliah.'}
                  Pastikan ID Semester sudah benar.
                </span>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-secondary"
                onClick={() => setShowSyncModal(false)}
                disabled={syncing}
              >
                Batal
              </button>
              <button
                className="btn btn-primary"
                onClick={handleSync}
                disabled={syncing || !syncConfig.id_semester}
              >
                {syncing ? 'Menyinkronkan...' : 'Mulai Sinkronisasi'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add Modal */}
      {showAddModal && (
        <div className="modal-overlay" onClick={() => setShowAddModal(false)}>
          <div className="modal-content modal-lg" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Tambah Kelas</h3>
            </div>
            <div className="modal-body">
              <div className="form-row">
                <div className="form-group">
                  <label>Nama Kelas <span className="required">*</span></label>
                  <input
                    type="text"
                    name="nama_kelas_kuliah"
                    value={formData.nama_kelas_kuliah}
                    onChange={handleInputChange}
                    placeholder="Contoh: A"
                  />
                </div>
                <div className="form-group">
                  <label>Kode Mata Kuliah</label>
                  <input
                    type="text"
                    name="kode_mata_kuliah"
                    value={formData.kode_mata_kuliah}
                    onChange={handleInputChange}
                    placeholder="Contoh: MK101"
                  />
                </div>
              </div>
              <div className="form-group">
                <label>Nama Mata Kuliah</label>
                <input
                  type="text"
                  name="nama_mata_kuliah"
                  value={formData.nama_mata_kuliah}
                  onChange={handleInputChange}
                  placeholder="Contoh: Algoritma dan Pemrograman"
                />
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>SKS</label>
                  <input
                    type="number"
                    name="sks"
                    value={formData.sks}
                    onChange={handleInputChange}
                    placeholder="3"
                    min="0"
                  />
                </div>
                <div className="form-group">
                  <label>Semester</label>
                  <input
                    type="text"
                    name="nama_semester"
                    value={formData.nama_semester}
                    onChange={handleInputChange}
                    placeholder="2024/2025 Ganjil"
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Program Studi</label>
                  <input
                    type="text"
                    name="nama_program_studi"
                    value={formData.nama_program_studi}
                    onChange={handleInputChange}
                    placeholder="S1 Keperawatan"
                  />
                </div>
                <div className="form-group">
                  <label>Nama Dosen</label>
                  <input
                    type="text"
                    name="nama_dosen"
                    value={formData.nama_dosen}
                    onChange={handleInputChange}
                    placeholder="Nama Dosen Pengampu"
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Kapasitas</label>
                  <input
                    type="number"
                    name="kapasitas"
                    value={formData.kapasitas}
                    onChange={handleInputChange}
                    placeholder="40"
                    min="0"
                  />
                </div>
                <div className="form-group">
                  <label>Jumlah Mahasiswa</label>
                  <input
                    type="text"
                    name="jumlah_mahasiswa"
                    value={formData.jumlah_mahasiswa}
                    onChange={handleInputChange}
                    placeholder="0"
                    readOnly
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-secondary"
                onClick={() => {
                  setShowAddModal(false);
                  resetForm();
                }}
                disabled={saving}
              >
                Batal
              </button>
              <button
                className="btn btn-primary"
                onClick={handleAddKelas}
                disabled={saving}
              >
                {saving ? 'Menyimpan...' : 'Simpan'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Edit Modal */}
      {showEditModal && selectedKelas && (
        <div className="modal-overlay" onClick={() => setShowEditModal(false)}>
          <div className="modal-content modal-lg" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Edit Kelas</h3>
            </div>
            <div className="modal-body">
              <div className="form-row">
                <div className="form-group">
                  <label>Nama Kelas <span className="required">*</span></label>
                  <input
                    type="text"
                    name="nama_kelas_kuliah"
                    value={formData.nama_kelas_kuliah}
                    onChange={handleInputChange}
                    placeholder="Contoh: A"
                  />
                </div>
                <div className="form-group">
                  <label>Kode Mata Kuliah</label>
                  <input
                    type="text"
                    name="kode_mata_kuliah"
                    value={formData.kode_mata_kuliah}
                    onChange={handleInputChange}
                    placeholder="Contoh: MK101"
                  />
                </div>
              </div>
              <div className="form-group">
                <label>Nama Mata Kuliah</label>
                <input
                  type="text"
                  name="nama_mata_kuliah"
                  value={formData.nama_mata_kuliah}
                  onChange={handleInputChange}
                  placeholder="Contoh: Algoritma dan Pemrograman"
                />
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>SKS</label>
                  <input
                    type="number"
                    name="sks"
                    value={formData.sks}
                    onChange={handleInputChange}
                    placeholder="3"
                    min="0"
                  />
                </div>
                <div className="form-group">
                  <label>Semester</label>
                  <input
                    type="text"
                    name="nama_semester"
                    value={formData.nama_semester}
                    onChange={handleInputChange}
                    placeholder="2024/2025 Ganjil"
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Program Studi</label>
                  <input
                    type="text"
                    name="nama_program_studi"
                    value={formData.nama_program_studi}
                    onChange={handleInputChange}
                    placeholder="S1 Keperawatan"
                  />
                </div>
                <div className="form-group">
                  <label>Nama Dosen</label>
                  <input
                    type="text"
                    name="nama_dosen"
                    value={formData.nama_dosen}
                    onChange={handleInputChange}
                    placeholder="Nama Dosen Pengampu"
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Kapasitas</label>
                  <input
                    type="number"
                    name="kapasitas"
                    value={formData.kapasitas}
                    onChange={handleInputChange}
                    placeholder="40"
                    min="0"
                  />
                </div>
                <div className="form-group">
                  <label>Jumlah Mahasiswa</label>
                  <input
                    type="text"
                    name="jumlah_mahasiswa"
                    value={formData.jumlah_mahasiswa}
                    onChange={handleInputChange}
                    placeholder="0"
                    readOnly
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-secondary"
                onClick={() => {
                  setShowEditModal(false);
                  setSelectedKelas(null);
                  resetForm();
                }}
                disabled={saving}
              >
                Batal
              </button>
              <button
                className="btn btn-primary"
                onClick={handleUpdateKelas}
                disabled={saving}
              >
                {saving ? 'Menyimpan...' : 'Update'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Delete Modal */}
      {showDeleteModal && selectedKelas && (
        <div className="modal-overlay" onClick={() => setShowDeleteModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Konfirmasi Hapus</h3>
            </div>
            <div className="modal-body">
              <div className="alert alert-error">
                <FiAlertCircle />
                <span>Apakah Anda yakin ingin menghapus kelas ini?</span>
              </div>
              <div style={{ marginTop: '15px', padding: '15px', background: '#f8f9fa', borderRadius: '8px' }}>
                <p style={{ margin: '0 0 5px 0', fontSize: '14px', color: '#7f8c8d' }}>Nama Kelas:</p>
                <p style={{ margin: '0', fontSize: '16px', fontWeight: '600', color: '#2c3e50' }}>
                  {selectedKelas.nama_kelas_kuliah} - {selectedKelas.nama_mata_kuliah}
                </p>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-secondary"
                onClick={() => {
                  setShowDeleteModal(false);
                  setSelectedKelas(null);
                }}
                disabled={deleting}
              >
                Batal
              </button>
              <button
                className="btn btn-danger"
                onClick={handleDeleteKelas}
                disabled={deleting}
              >
                {deleting ? 'Menghapus...' : 'Ya, Hapus'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Detail Modal */}
      {showDetailModal && selectedKelas && (
        <div className="modal-overlay" onClick={() => setShowDetailModal(false)}>
          <div className="modal-content modal-lg" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Detail Kelas</h3>
            </div>
            <div className="modal-body">
              <div className="detail-section">
                <h4><FiGrid /> Informasi Kelas</h4>
                <div className="detail-grid">
                  <div className="detail-item">
                    <label>Nama Kelas:</label>
                    <p>{selectedKelas.nama_kelas_kuliah}</p>
                  </div>
                  <div className="detail-item">
                    <label>Kapasitas:</label>
                    <p>{selectedKelas.kapasitas} mahasiswa</p>
                  </div>
                  <div className="detail-item">
                    <label>Kode Mata Kuliah:</label>
                    <p>{selectedKelas.kode_mata_kuliah}</p>
                  </div>
                  <div className="detail-item">
                    <label>Nama Mata Kuliah:</label>
                    <p>{selectedKelas.nama_mata_kuliah}</p>
                  </div>
                  <div className="detail-item">
                    <label>SKS:</label>
                    <p>{selectedKelas.sks}</p>
                  </div>
                  <div className="detail-item">
                    <label>Dosen Pengampu:</label>
                    <p>{selectedKelas.nama_dosen || '-'}</p>
                  </div>
                  <div className="detail-item">
                    <label>Semester:</label>
                    <p>{selectedKelas.nama_semester}</p>
                  </div>
                  <div className="detail-item">
                    <label>Program Studi:</label>
                    <p>{selectedKelas.nama_program_studi}</p>
                  </div>
                  <div className="detail-item">
                    <label>Kapasitas:</label>
                    <p>{selectedKelas.kapasitas} mahasiswa</p>
                  </div>
                  <div className="detail-item">
                    <label>Jumlah Mahasiswa:</label>
                    <p>{selectedKelas.jumlah_mahasiswa || '0'} mahasiswa</p>
                  </div>
                </div>
              </div>

              {selectedKelas.tanggal_mulai_efektif && (
                <div className="detail-section">
                  <h4><FiCalendar /> Periode</h4>
                  <div className="detail-grid">
                    <div className="detail-item">
                      <label>Tanggal Mulai:</label>
                      <p>{selectedKelas.tanggal_mulai_efektif}</p>
                    </div>
                    <div className="detail-item">
                      <label>Tanggal Selesai:</label>
                      <p>{selectedKelas.tanggal_akhir_efektif}</p>
                    </div>
                  </div>
                </div>
              )}

              <div className="detail-section">
                <h4><FiUsers /> Peserta Kelas ({selectedKelas.jumlah_mahasiswa || '0'})</h4>
                {selectedKelas.peserta_kelas && selectedKelas.peserta_kelas.length > 0 ? (
                  <div className="peserta-list">
                    {selectedKelas.peserta_kelas.slice(0, 10).map((peserta, idx) => (
                      <div key={idx} className="peserta-item">
                        <span className="peserta-nim">{peserta.nim}</span>
                        <span className="peserta-nama">{peserta.nama_mahasiswa}</span>
                      </div>
                    ))}
                    {selectedKelas.peserta_kelas.length > 10 && (
                      <p style={{ color: '#7f8c8d', fontSize: '13px', marginTop: '10px' }}>
                        ... dan {selectedKelas.peserta_kelas.length - 10} mahasiswa lainnya
                      </p>
                    )}
                  </div>
                ) : (
                  <p style={{ color: '#7f8c8d', fontSize: '14px', fontStyle: 'italic' }}>
                    {selectedKelas.jumlah_mahasiswa === '0' || !selectedKelas.jumlah_mahasiswa 
                      ? 'Belum ada mahasiswa yang terdaftar' 
                      : 'Detail peserta tidak tersedia (gunakan jumlah_mahasiswa dari NEO Feeder)'}
                  </p>
                )}
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-secondary"
                onClick={() => {
                  setShowDetailModal(false);
                  setSelectedKelas(null);
                }}
              >
                Tutup
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Peserta Modal */}
      {showPesertaModal && selectedKelas && (
        <div className="modal-overlay" onClick={() => setShowPesertaModal(false)}>
          <div className="modal-content modal-lg" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>
                <FiUsers /> Daftar Peserta Kelas
              </h3>
              <button className="btn-close" onClick={() => setShowPesertaModal(false)}>×</button>
            </div>
            <div className="modal-body">
              {/* Info Kelas */}
              <div className="peserta-kelas-info">
                <div className="info-row">
                  <div className="info-item">
                    <label>Mata Kuliah:</label>
                    <strong>{selectedKelas.kode_mata_kuliah} - {selectedKelas.nama_mata_kuliah}</strong>
                  </div>
                  <div className="info-item">
                    <label>Kelas:</label>
                    <strong>{selectedKelas.nama_kelas_kuliah || '-'}</strong>
                  </div>
                </div>
                <div className="info-row">
                  <div className="info-item">
                    <label>Semester:</label>
                    <span>{selectedKelas.nama_semester}</span>
                  </div>
                  <div className="info-item">
                    <label>Program Studi:</label>
                    <span>{selectedKelas.nama_program_studi}</span>
                  </div>
                </div>
                <div className="info-row">
                  <div className="info-item">
                    <label>Dosen:</label>
                    <span>{selectedKelas.nama_dosen || '-'}</span>
                  </div>
                  <div className="info-item">
                    <label>Jumlah Mahasiswa:</label>
                    <strong className="peserta-count-badge">
                      <FiUsers /> {selectedKelas.jumlah_mahasiswa || '0'}
                    </strong>
                  </div>
                </div>
              </div>

              <hr style={{ margin: '20px 0', border: 'none', borderTop: '1px solid #ecf0f1' }} />

              {/* List Peserta */}
              {loadingPeserta ? (
                <div className="loading-peserta">
                  <div className="spinner"></div>
                  <p>Memuat data peserta dari NEO Feeder...</p>
                </div>
              ) : pesertaList.length > 0 ? (
                <div className="peserta-table-container">
                  <table className="peserta-table">
                    <thead>
                      <tr>
                        <th style={{ width: '60px', textAlign: 'center' }}>No</th>
                        <th style={{ width: '150px' }}>NIM</th>
                        <th>Nama Mahasiswa</th>
                        <th style={{ width: '100px', textAlign: 'center' }}>Angkatan</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pesertaList.map((peserta, index) => (
                        <tr key={peserta.id_peserta_kelas || index}>
                          <td style={{ textAlign: 'center' }}>{index + 1}</td>
                          <td><strong>{peserta.nim}</strong></td>
                          <td>{peserta.nama_mahasiswa}</td>
                          <td style={{ textAlign: 'center' }}>{peserta.angkatan || '-'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="peserta-summary">
                    <FiUsers /> Total: <strong>{pesertaList.length} mahasiswa</strong>
                  </div>
                </div>
              ) : (
                <div className="no-peserta">
                  <FiAlertCircle size={48} color="#95a5a6" />
                  <p>
                    {selectedKelas.jumlah_mahasiswa === '0' || !selectedKelas.jumlah_mahasiswa
                      ? 'Belum ada mahasiswa yang terdaftar di kelas ini'
                      : 'Data peserta tidak ditemukan di NEO Feeder'}
                  </p>
                  {selectedKelas.jumlah_mahasiswa > 0 && (
                    <small style={{ color: '#7f8c8d' }}>
                      Jumlah mahasiswa tercatat: {selectedKelas.jumlah_mahasiswa}
                    </small>
                  )}
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-secondary"
                onClick={() => setShowPesertaModal(false)}
              >
                Tutup
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Kelas;
